var exports = {
  "A": "menuButton__3XK6NH",
};

module.exports = exports;
